export default "/static/1a7135c9a90a8c08.svg"